module.exports = __webpack_public_path__ + "img/008.7626571d.jpg";